import { MenuItem } from '@fountain/fountain-ui-components';
import { Avatar, Menu } from '@material-ui/core';
import { CareerSiteSsoUserDetails } from 'api-clients/monolith';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router-dom';
import { RouteParams } from 'types';

import { domainMeta } from 'utils/domainMeta';

import { Button } from './ui/button';

interface AuthControlProps {
  ssoUserDetails: CareerSiteSsoUserDetails;
}

export function AuthControl({ ssoUserDetails }: AuthControlProps) {
  const { accountSlug, brandId } = useParams<RouteParams>();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const getAuthUrl = (path: string) => {
    const brandIdParam = brandId ? `?brand_id=${brandId}` : '';
    return new URL(
      `${domainMeta.monolithOrigin}/internal_api/career_site/auth/sso/${accountSlug}/${path}${brandIdParam}`,
    );
  };
  const onLogin = () => {
    window.location.replace(getAuthUrl('saml/login'));
  };
  const onLogout = () => {
    window.location.replace(getAuthUrl('saml/logout'));
  };

  if (ssoUserDetails && ssoUserDetails.email) {
    return (
      <div className="flex h-16 items-center justify-center p-6">
        <div className="flex-end flex items-end gap-4">
          <Avatar
            onClick={handleClick}
            className="!h-8 !w-8 cursor-pointer border border-[#D6D9E4] !bg-white !text-[#131E40]"
          >
            {ssoUserDetails.email.charAt(0).toUpperCase()}
          </Avatar>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            PaperProps={{
              className:
                '!min-w-[207px] !min-h-[103px] !rounded-[5px] border border-gray-300',
            }}
          >
            <MenuItem
              onClick={handleClose}
              className="no-focus-style flex h-[44px] min-w-[205px] gap-2 !bg-white px-4 py-3"
            >
              <p className="flex h-[20px] min-w-[173px] flex-col gap-1 text-sm italic">
                {ssoUserDetails.email}
              </p>
            </MenuItem>

            <MenuItem
              onClick={onLogout}
              className="flex h-[44px] !w-[205px] gap-2 px-4 py-3"
            >
              <p className="flex h-[20px] min-w-[173px] flex-col gap-1 text-sm not-italic">
                <FormattedMessage
                  defaultMessage="Logout"
                  description="Logout button label"
                />
              </p>
            </MenuItem>
          </Menu>
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-16 items-center justify-center p-3">
      <Button onClick={() => onLogin()} className="text-base font-medium">
        <FormattedMessage
          defaultMessage="Worker Login"
          description="Worker login button label"
        />
      </Button>
    </div>
  );
}
